import * as getters from "../getters";

export function hideUnnecessaryIcons()
{
    $('body .dataTables_scrollBody .datatables-expand-data').each((index, td) => {
        const tr = td.closest('tr');
        const instance = getters.getCurrentTableInstance(tr);

        if (tr && instance) {
            const row = instance.row(tr);
            const data = row.data();

            if ((data && data.hasOwnProperty('show_expand_data') && !data.show_expand_data) || (data && !data.hasOwnProperty('show_expand_data'))) {
                const i = td.querySelector('i');
                i.classList.add('d-none');
            }
        }
    });
}

export function showRows()
{
    $('body').on('click', '.dataTables_scrollBody tr td:not(:first-child), .dataTables_scrollBody tr td:first-child input:checked', e => {
        const tr = e.currentTarget.closest('tr');
        if (tr.querySelector('.datatables-expand-data i.d-none') || !tr.querySelector('.datatables-expand-data') || e.target.tagName === 'BUTTON' || e.target.closest('button') || e.target.tagName === 'A' || e.target.closest('a')) {
            return;
        }
        const stripedStartClass = tr.classList.contains('odd') ? 'odd' : 'even'
        const container = getters.getContainer(tr);
        const table = getters.getTable(container);
        const instance = getters.getCurrentTableInstance(tr);
        const row = instance.row(tr);
        const data = row.data();
        if (data) {
            const i = tr.querySelector('.datatables-expand-data i');

            if (i.classList.contains('fa-sort-up') && e.currentTarget.tagName.toUpperCase() !== 'INPUT') {
                row.child.hide();
                tr.classList.remove('shown');
                i.classList.add('fa-sort-down');
                i.classList.remove('fa-sort-up');

                return;
            }

            $.ajax({
                url: instance.ajax.url(),
                type: 'POST',
                dataType: 'json',
                data: {
                    expand_data: true,
                    item_id: data.expand_data_id,
                    custom_params: JSON.stringify(datatables.getCustomParams(instance)),
                    select_all_ids: !!container.querySelector('.table-datatable-select-all-toggler[data-selected="true"]')
                },
                success: d => {
                    if (!d.expand_data) {
                        throw new Error('Wystąpił błąd, klucz expand_data nie istnieje.');
                    }

                    if (d.expand_data.length == 0) {
                        return false;
                    }

                    tr.classList.add('has-inner-table');
                    const originalAction = tr.querySelector('[name="action_ids[]"]');
                    const checkedAction = originalAction.checked;

                    const expandColumns = getters.getExpandColumns(table);
                    const fixedExpandColumnPositions = fixColumnPositions(instance);

                    addTableRow(instance, row, tr, i, d, fixedExpandColumnPositions, stripedStartClass);
                    setProperlyWidthsForRows(instance, container, expandColumns);
                    //po zmianie szerokości kolumn ponownie przeliczamy scrollbar

                    document.querySelectorAll('.table-datatable').forEach((table) => {
                        table.classList.add('table-datatable-dont-refresh')
                        const container = getters.getContainer(table)
                        datatables.addFloatingScrollbarToTable(container)
                    });


                    const trInnerTable = tr.nextElementSibling
                    if (trInnerTable) {
                        trInnerTable.classList.add(stripedStartClass)
                    }
                    if (trInnerTable && trInnerTable.classList.contains('is-inner-table') && (tr.querySelector('[name="action_ids[]"]:checked') || container.querySelector('.select-all-visible-checkboxes input:checked') || container.querySelector('.table-datatable-select-all-toggler[data-selected="true"]'))) {
                        let checkboxes = {};
                        if (sessionStorage.getItem('datatable_checkboxes')) {
                            checkboxes = JSON.parse(sessionStorage.getItem('datatable_checkboxes'));
                        }
                        trInnerTable.querySelectorAll('[name="expand_action_ids[]"]').forEach(expand => {
                            const includes = `${originalAction.value}|${expand.value}`;
                            if (checkboxes[table.id] && checkboxes[table.id]['expand_action_ids[]'] && checkboxes[table.id]['expand_action_ids[]'].includes(includes)) {
                                expand.checked = true;
                                expand.closest('tr').classList.add('row-selected');
                            } else {
                                expand.checked = checkedAction;
                                expand.closest('tr').classList.add('row-selected');
                            }
                        });
                    }

                    $('[data-toggle="tooltip"]').tooltip()

                    setTimeout(function () {
                        Validation.initForms();
                    }, 300);
                }
            })
        }
    });
}

export function expandTable(instance, row, data, expandColumns)
{
    const tableElement = getters.getTableElementById(getters.getInstanceId(instance.context[0]))
    if (!tableElement) {
        return
    }
    const allColumns = JSON.parse(tableElement.dataset.columns)
    const lowestIndex = getLowestColumn(JSON.parse(tableElement.dataset.expandColumns))
    let table = '<table class="table-datatable table table-designed dataTable table-datatable-rendered no-footer"><tbody>';
    const originalActionValue = row.selector.rows.querySelector('[name="action_ids[]"]').value;

    data.expand_data.forEach(item => {
        table += '<tr >';
        let progressClass = ''
        if (item.hasOwnProperty('is_progress_class') && item.is_progress_class) {
            progressClass = item.is_progress_class
        }

        if (item.display_actions) {
            // Później gdybyśmy mieli przywrócić checkboxy to ten IF przesuwamy, aby wrzucał tylko action-items
            let itemActionParent = instance.column(1).nodes().to$()[0];
            table += `<td class="td-inner-action border-top-0 border-right-0 border-bottom-0 ${progressClass ? progressClass : itemActionParent ? itemActionParent.classList.value : ''}">`;
            table += '<div class="d-flex">';
            table += `<input type="hidden" value="${item.id}" name="expand_action_ids[]" id="expand-selection-ids-s-${item.id}">`;
            table += `<input type="hidden" value="${item.groupedIds}" name="grouped_ids[]" id="expand-selection-ids-s-${item.id}">`;
            // table += '<div class="custom-control custom-checkbox d-none">';
            // table += `<input type="checkbox" class="custom-control-input" value="${item.id}" name="expand_action_ids[]" data-additional-value="${item.additional_value}" id="expand-selection-ids-s-${originalActionValue}-${item.id}">`;
            // table += `<label for="expand-selection-ids-s-${originalActionValue}-${item.id}" class="custom-control-label"></label>`;
            // table += '</div>';


            table += '<div class="dropdown action-items">'
            table += '<button class="btn btn-link dropdown-toggle pr-1 is-expand" data-load-action-row type="button" id="row-options-' + item.id + '" data-toggle="dropdown" data-boundary="scrollParent" aria-haspopup="true" aria-expanded="false" data-table-id="' + instance.context[0].sInstance + '" data-element-id="' + item.id + '" data-grouped-ids="' + (item.groupedIds ?? '') + '">'
            table += '<span class="row-action-pointer"></span>'
            table += '<span class="row-action-pointer"></span>'
            table += '<span class="row-action-pointer"></span>'
            table += '</button>'
            table += '<div class="dropdown-menu action-menu" aria-labelledby="row-options-' + item.id + '"></div>'
            table += '</div>'

            table += '</div>';
            table += '</td>';
        }

        allColumns.forEach((column, index) => {
            if (index >= lowestIndex) {
                let splitted = expandColumns[index]?.split(':');
                let value = splitted ? (item[splitted[0]] ? item[splitted[0]] : '-') : '-';
                let newIndex = splitted ? splitted[1] : index
                let visibility = instance.column(newIndex).visible() ? '' : 'd-none';
                let alignTextClass = 'text-left';
                let item0 = instance.column(newIndex).nodes().to$()[0];
                table += `<td class="${visibility} border-0 ${alignTextClass} td-inner ${progressClass ? progressClass : item0 ? item0.classList.value : ''}" data-expand-column-index="${newIndex}">${value}</td>`;
            }
        })

        table += '</tr>';
    });
    table += '</tbody></table>';

    return table;
}

export function setProperlyWidthsForRows(instance, container, expandColumns)
{
    // Ustawia długości poszczególnych kolumn
    const tableElement = getters.getTableElementById(getters.getInstanceId(instance.context[0]))
    const allColumns = JSON.parse(tableElement.dataset.columns)
    allColumns.forEach((column, index) => {
        if (index >= 3) {
            const allColumnElements = container.querySelectorAll(`th[data-column-index="${index}"], td[data-column-index="${index}"], td[data-expand-column-index="${index}"]`);
            let maxWidth = 0;
            allColumnElements.forEach(td => {
                const cellWidth = getTextWidth(td);
                if (cellWidth > maxWidth) {
                    maxWidth = cellWidth;
                }
            });
            $(`.table-datatable th[data-column-index="${index}"]`).css({
                'width': `${maxWidth + 40.5}px`,
                'min-width': `${maxWidth + 40.5}px`,
                'max-width': `${maxWidth + 40.5}px`,
            })

            $(`.table-datatable td[data-column-index="${index}"], .is-inner-table td[data-expand-column-index="${index}"]`).css({
                'width': `${maxWidth + 40.5}px`,
                'min-width': `${maxWidth + 40.5}px`,
                'max-width': `${maxWidth + 40.5}px`,
            })                

        }
    });

    const firstExpandColumn = expandColumns[0].split(':')[1];
    const th = container.querySelector(`.dataTables_scrollHead thead th[data-column-index="${firstExpandColumn}"]`);
    const prevTh = $(th).prevAll();
    let width = 0;
    prevTh.each((index, item) => {
        width += $(item).outerWidth();
    });

    // Ustawia odpowiednie przesunięcie wewnętrznej tabeli
    $('tr.has-inner-table').each((index, item) => {
        const id = item.id;

        let actionLength = 4
        if ($(`.is-inner-table[data-parent="${id}"] .action-items`).length > 0) {
            actionLength = 53
        } else {
            actionLength = 4
        }

        $(`.is-inner-table[data-parent="${id}"] > td`).css('padding-left', `${width - actionLength}px`);
    });  
}

function getTextWidth(td) {
    const range = document.createRange();
    range.selectNodeContents(td);

    const rect = range.getBoundingClientRect();
    return rect.width;
  }

// Ustawia odpowiednie pozycje kolumn po reorderze
export function fixColumnPositions(instance)
{
    const state = instance.state();
    const colReorder = state.ColReorder;
    let columns = [];
    const tableElement = getters.getTableElementById(getters.getInstanceId(instance.context[0]))
    if (tableElement) {
        const originalExpandColumns = JSON.parse(tableElement.dataset.expandColumns)

        originalExpandColumns.forEach(col => {
            let splitted = col.split(':');
            let index = parseInt(splitted[1]);
            let newIndex = colReorder.findIndex((item) => item === index);
            let name = getColumnNameByIndex(originalExpandColumns, index);
            columns[newIndex] = `${name}:${newIndex}`;
        });
    }

    return columns;
}

export function getColumnNameByIndex(expandColumns, newIndex)
{
    let name = '';
    expandColumns.forEach(column => {
        let splitted = column.split(':');
        let currentName = splitted[0];
        let index = splitted[1];

        if (index == newIndex) {
            name = currentName;
        }
    });

    return name;
}

export function addTableRow(instance, row, tr, i, data, fixedExpandColumnPositions, stripedStartClass)
{
    row.child(expandTable(instance, row, data, fixedExpandColumnPositions, stripedStartClass), 'is-inner-table').show();
    row.child().attr('data-parent', tr.id);
    tr.classList.add('shown');
    i.classList.remove('fa-sort-down');
    i.classList.add('fa-sort-up');
}

export function clearRowsAndAddNewAfterColReorder(instance, container)
{
    const openedTrs = container.querySelectorAll('.has-inner-table.shown');
    openedTrs.forEach(tr => {
        const button = tr.querySelector('.datatables-expand-data');

        setTimeout(() => {
            button.click();
            button.click();
        }, 20);
    });
}

export function getHighestColumn(expandColumns)
{
    let index = 0;

    expandColumns.forEach(column => {
        let columnIndex = parseInt(column.split(':')[1]);

        if (columnIndex > index) {
            index = columnIndex;
        }
    });

    return parseInt(index);
}

export function getLowestColumn(expandColumns)
{
    let index = 1000;

    expandColumns.forEach(column => {
        let columnIndex = parseInt(column.split(':')[1]);
        if (columnIndex < index) {
            index = columnIndex;
        }
    });

    return parseInt(index);
}
